var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png"),"alt":"logo"}}),_c('ul',{staticStyle:{"display":"flex"}},[_c('li',[_vm._v("开发者中心")])])])])
}]

export { render, staticRenderFns }